import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormArray, FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";
import { GUID } from "./../../guid";
@Component({
  selector: "app-metafieldhistory",
  templateUrl: "./metafieldhistory.component.html",
  styleUrls: ["./metafieldhistory.component.scss"],
})
export class MetafieldhistoryComponent implements OnInit {
  mode: any;
  metaobjectId: any;
  metaobjectName: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaobjectList = [];
  guid: GUID;

  sorting = {
    fieldName: "labelname",
    order: "ASC",
  };

  form: FormGroup;
  metafieldList = [];
  metafieldListChanges = [];
  metafieldHistoryList = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      fieldList: [],
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
    });

    console.log("mode", this.mode);
    this.guid = new GUID();

    // this.getMetaobjectById();
    // this.getMetafields();
    // this.getMetafieldHistory();
    this.getMetafields().then(() => {
      this.getMetafieldHistory();
    });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  getMetaobjectById() {
    return new Promise((resolve, reject) => {
      console.log("getMetaobjectById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            id: this.metaobjectId,
          },
        },
      };

      this.isLoading = true;
      this.dataService.getMetaobjectById(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metaobjectList = res.data.metaobject;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No Object data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetafields() {
    return new Promise((resolve, reject) => {
      console.log("getMetafields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          sortfield: this.sorting.fieldName,
          sortorder: this.sorting.order,
          metafield: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaFields(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metafieldList = res.data.metafields;
            //assign table data will refresh it automatically
            // this.dataSource.data = this.metafieldList;
            console.log(res.data.metafields);
            this.metafieldList = res.data.metafields.filter(
              (field) => field.attributes.length < "255"
            );

            this.metafieldList.forEach((field) => {
              field.selected = false;
              field.trackchangesonly = false;
            });

            this.metafieldListChanges = res.data.metafields.filter(
              (field) => field.attributes.length >= "255"
            );

            this.metafieldListChanges.forEach((field) => {
              field.selected = false;
              field.trackchangesonly = true;
            });

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metafields data!");
            this.errorMessage =
              res != null ? res.message : "No metafields data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetafieldHistory() {
    return new Promise((resolve, reject) => {
      console.log("getMetafieldHistory");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafieldhistory: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaFieldHistory(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metafieldHistoryList = res.data.metafieldhistory;
            //assign table data will refresh it automatically
            // this.metafieldhistory = true;
            this.metafieldList.forEach((field) => {
              const foundField = this.metafieldHistoryList.find(
                (historyField) => historyField.metafieldid === field.id
              );
              console.log(foundField);

              if (foundField) {
                field.selected = true;
              } else {
                field.selected = false;
              }
            });

            this.metafieldListChanges.forEach((field) => {
              const foundField = this.metafieldHistoryList.find(
                (historyField) => historyField.metafieldid === field.id
              );
              console.log(foundField);

              if (foundField) {
                field.selected = true;
              } else {
                field.selected = false;
              }
            });

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metafieldhistory data!");
            this.errorMessage =
              res != null ? res.message : "No metafieldhistory data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  cancel() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  save() {
    const selectedFields = this.metafieldList.filter((field) => field.selected);
    const selectedFieldss = this.metafieldListChanges.filter(
      (field) => field.selected
    );

    const bothFields = selectedFields.concat(selectedFieldss);

    const finalFields = bothFields.map((field) => {
      return {
        metafieldid: field.id,
        metafieldname: field.labelname,
        metaobjectname: field.metaobjectname,
        metaobjectid: field.metaobjectid,
        selected: field.selected,
        trackchangesonly: field.trackchangesonly,
      };
    });
    console.log("Submission Payload:", finalFields);

    this.isLoading = false;
    this.isError = false;
    if (finalFields.length > 20) {
      this.showWarning("Field Selection cannot Exceed 20");
      return;
    }

    console.log("******************************");

    // You can now send this submission payload to your backend or handle it as needed
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profilename: userDetail.profilename,

      data: {
        metafieldhistory: [],
      },
    };

    for (var fieldHistory of finalFields) {
      var metaFieldHistory = {
        id: this.guid.getGUID("metafieldhistory"),
        organizationid: localStorage.getItem("crm_orgid"),
        metaobjectid: fieldHistory.metaobjectid,
        metaobjectname: fieldHistory.metaobjectname,
        metafieldname: fieldHistory.metafieldname,
        metafieldid: fieldHistory.metafieldid,
        trackchangesonly: fieldHistory.trackchangesonly,
        active: true,
        mode: this.mode,
      };

      //push it to array
      postOption.data.metafieldhistory.push(metaFieldHistory);
    }

    console.log(postOption);
    this.isLoading = true;

    this.dataService.upsertMetafieldHistory(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
